import { Col, Row } from '../components/custom';

import {
    NumbersRounded,
    InsightsRounded,
    AddchartRounded,
    StyleRounded,
    SettingsRounded,
    SettingsSuggestRounded,
    SendRounded,
    ScheduleSendRounded,
    AutoAwesomeRounded
} from '@mui/icons-material';

export default function Pricing()
{
    return (
        <Col id='pricing'>
            {/* <Col className='head'>
                <span className='title'>Some title here</span>
                <span className='desc'>Some description here</span>
            </Col> */}
            <Row className='prices'>
                <Col className='tier'>
                    <Col className='price'>
                        <span className='desc'>Standard Analysis</span>
                        {/* <span className='cost'>$100</span> */}
                        <span className='descsmall'>Descriptive Statistics, Inferential Statistics & Hypothesis Testing</span>
                    </Col>
                    <Col className='features'>
                        <Row className='feature'>
                            <NumbersRounded/>
                            <span className='descsmall'>Quantitative Survey Data</span>
                        </Row>
                        <Row className='feature'>
                            <InsightsRounded/>
                            <span className='descsmall'>Insights Summary</span>
                        </Row>
                        <Row className='feature'>
                            <AddchartRounded/>
                            <span className='descsmall'>Data Visualizations</span>
                        </Row>
                        <Row className='feature'>
                            <StyleRounded/>
                            <span className='descsmall'>Report Deliverables: Tables | Charts | Interpretation | Conclusion | Recommendations</span>
                        </Row>
                        <Row className='feature'>
                            <SettingsRounded/>
                            <span className='descsmall'>Complexity (Moderate) - Hypothesis Testing</span>
                        </Row>
                        <Row className='feature'>
                            <SendRounded/>
                            <span className='descsmall'>Delivery Time: 5 Business Days</span>
                        </Row>
                    </Col>
                </Col>
                <Col className='tier'>
                    <Col className='price'>
                        <span className='desc'>Advanced Analysis</span>
                        {/* <span className='cost'>$200</span> */}
                        <span className='descsmall'>Get the Standard Analysis with Advanced Modeling (Regression, Cluster, Conjoint, etc.)</span>
                    </Col>
                    <Col className='features'>
                        <Row className='feature'>
                            <NumbersRounded/>
                            <span className='descsmall'>Quantitative Survey Data</span>
                        </Row>
                        <Row className='feature'>
                            <InsightsRounded/>
                            <span className='descsmall'>Insights Summary</span>
                        </Row>
                        <Row className='feature'>
                            <AddchartRounded/>
                            <span className='descsmall'>Data Visualizations</span>
                        </Row>
                        <Row className='feature'>
                            <StyleRounded/>
                            <span className='descsmall'>Report Deliverables: Tables | Charts | Interpretation | Conclusion | Recommendations</span>
                        </Row>
                        <Row className='feature'>
                            <SettingsSuggestRounded/>
                            <span className='descsmall'>Complexity (High) - Multivariable Analysis</span>
                        </Row>
                        <Row className='feature'>
                            <AutoAwesomeRounded/>
                            <span className='descsmall'>Qualitative Survey Data: Word Cloud | N-Grams | Word Frequency | Polarity and Emotion Detection | Topic Modelling | Text Summary | Recommendations</span>
                        </Row>
                        <Row className='feature'>
                            <ScheduleSendRounded/>
                            <span className='descsmall'>Delivery Time: 10 Business Days</span>
                        </Row>
                    </Col>
                </Col>
            </Row>
        </Col>
    )
}